module.exports = __webpack_public_path__ + "static/media/icone_eliminar.f9df8f6d.svg";